<div class="bot-page-main">
  <app-header-bot></app-header-bot>

  <div class="bot-container">

    <div class="page-title-wrapper">
      <h4 class="page-title">CRED Hanuman Upside Bot</h4>
    </div>

    <div class="bot-split-row">

      <div class="bot-box-side-panel">
        <app-hanumanUpsideOrderbook></app-hanumanUpsideOrderbook>
      </div>
      <div class="bot-box-chart">
        <div class="botChart">
          <app-chart *ngIf="chartStatus" class="trade_chart baseblock_wrapper" [chartData]="chartData"></app-chart>
        </div>
      </div>

      <div class="bot-box-side-panel">
        <app-hanumanUpsideOpenPosition></app-hanumanUpsideOpenPosition>
      </div>

    </div>

    <div class="bot-middle-row">
      <app-adminBotUpsideHanumanTopGainer></app-adminBotUpsideHanumanTopGainer>
    </div>

    <div class="bot-history">
      <app-adminBotUpsideHanumanOrderHistory (botSelected)="onBotSelected($event)">
      </app-adminBotUpsideHanumanOrderHistory>
    </div>

  </div>
</div>